import BootstrapService from './bootstrap-service';

/***
 * A Service used to get application settings
 */
const bootstrap = angular
    .module('FacilityData.Common.Bootstrap', [])
    .service('BootstrapSettings', BootstrapService)
    .name;

export default bootstrap;


// WEBPACK FOOTER //
// ./app/common/bootstrap/bootstrap.js